import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormCreatorService, IConfigurationSection } from '../../../services';
import { ConfigurationType } from '../../../shared/enums/ConfigurationType';

@Component({
  selector: 'app-form-section-title',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-section-title.component.html',
  styles: `
    :host {
      display: contents;
    }
  `
})
export class FormSectionTitleComponent {
  @Input() title !: string;
  @Input() isDesigner !: boolean;

  constructor(private fc: FormCreatorService) { }

  onShowConfiguration(event: Event) {
    event.stopPropagation();
    if(!this.isDesigner) return
    const configuration = {show: true, type: ConfigurationType.Global} as IConfigurationSection;
    this.fc.emitShowConfigurationEvent(configuration, event.currentTarget as HTMLElement);
  }

  onHandleKey(event: KeyboardEvent) {
    event.stopPropagation();
    if(!this.isDesigner) return
    if (event.key === 'Enter' || event.key === ' ') {
      const configuration = {show: true, type: ConfigurationType.Global} as IConfigurationSection;
      this.fc.emitShowConfigurationEvent(configuration, event.currentTarget as HTMLElement);
    }
  }
}
